import { useForm } from "react-hook-form"
import { useState } from "react"
import { transactionStatus, changePasswordService } from "./passwordServices"


export const useRecoverSubmit = (id) => {

    const [message, setMessage] = useState('')
    const [response, setResponse] = useState(null)
    const { register, handleSubmit, formState: { errors } } = useForm({
        mode: "onBlur",
    })

    //console.log('id recover: ', id)

    const onSubmit = async (data) => {
        try {


            const finalData = {
                ...data,
                transactionId: id
            }
            //console.log('finalData: ', finalData)

               const result = await changePasswordService(finalData)


               if (result) {
                   setResponse(result)
               }
               //console.log('resultado ', result)
               setMessage(result.data.message)

        } catch (error) {
            // console.error(error);
            setMessage(error.message)
            setResponse(error.status)
        }
    }

    return { register, handleSubmit, onSubmit, errors, message, response }
}

export const getIdStatus = async (id) => {


    try {
        const status = await transactionStatus(id)

        //console.log('PasswordController Status: ', status)

        return status
    } catch (error) {
        // console.error('PasswordController Error:', error)

        return error
    }

    
}